import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { environment } from 'src/environments/environment';
import { catchError,map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CartasAmonestacionService {

  constructor(
    private http:HttpClient,
    private router: Router,
    private alert:AlertHelper
  ) { }
  //traerTodas
  traerTodasCartas(): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/cartasamonestacion`)
    .pipe(
      map((res:RequestResponse) =>{ 
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //eliminarCarta
  eliminarCartaAmonestacion(id:number):Observable<RequestResponse> {
    return this.http  
      .delete<RequestResponse>(`${environment.API}/rrhh/cartasamonestacion/eliminar/${id}`)
  }
  //TraerArchivo
  traerArchivoCarta(id:any): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/documento/buscarcartasporid/${id}`)
    .pipe(
      map((res:RequestResponse) =>{ 
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerPorRut
  traerCartaPorTrabajador(id:any): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/cartasamonestacion/idTrabajador/${id}`)
    .pipe(
      map((res:RequestResponse) =>{ 
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //TraerPorRutAsync
  async traerCartaPorTrabajadorAsync(id: number): Promise<RequestResponse> {
    try {
      return await this.http.get<RequestResponse>(`${environment.API}/rrhh/cartasamonestacion/idTrabajador/${id}`).toPromise();
    } catch (error) {
      return { success: false, msg: 'Hubo un error al obtener las cartas-' } as RequestResponse;
    }
  }

  private handlerError(err: any):Observable<never>{
    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }
}
